/**
 * When one of the storage functions throws, the thrown StorageError
 * will have a .code property that contains one of these values.
 *
 * @modified 5.0.0
 */
export var StorageErrorType;
(function (StorageErrorType) {
    /**
     * The key is null or empty.
     */
    StorageErrorType["missingKey"] = "missingKey";
    /**
     * `get()` found the data, but it is corrupted.
     */
    StorageErrorType["invalidData"] = "invalidData";
    /**
     * A system-level error occurred when getting/setting data from/to the store.
     */
    StorageErrorType["osError"] = "osError";
    /**
     * An unclassified system-level error occurred.
     */
    StorageErrorType["unknownError"] = "unknownError";
})(StorageErrorType || (StorageErrorType = {}));
/**
 * If one of the storage functions throws, it will throw a StorageError which
 * will have a .code property that can be tested against StorageErrorType,
 * and a .message property will have a message suitable for debugging purposes.
 *
 * @modified 5.0.0
 */
export class StorageError extends Error {
    constructor(message, code) {
        super(message);
        this.name = this.constructor.name;
        this.code = code;
    }
}
